/**
 * 倒计时
 */
import {useEffect, useState} from 'react'

export const useCountdown = () => {
  const [leftTime, setLeftTime] = useState(0);

  useEffect(() => {
    const timer = setTimeout(() => {
      if(leftTime <= 0) return clearTimeout(timer);
      setLeftTime(leftTime - 1);
    }, 1000);

    return () => clearTimeout(timer);
  }, [leftTime]);

  return [leftTime, setLeftTime] as const;
}
